<template>
  <div class="inner-banner breadcrumb-area-info1 main-banner">
    <div class="image-layer" style="background-image: url(/assets/images/shape/shape-25.png);"></div>
    <div class="container">
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <div class="breadcrumb-content">
            <div class="section-title white-2">
              <h4>Service</h4>
              <h1 class="mt-3">{{ detail.title }}</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <section class="auninfo_contact cantact_v2 section_padding margin-top-about breadcrumb-area-biz">
    <div class="container">
      <div class="block-title text-center" data-aos="fade-right" :data-aos-duration="500">
        <p><span>Service Detail</span></p>
      </div>
      <div class="about-one__content">
        <div class="about-one__box-wrapper">
          <div class="about-one__box">
            <div class="about-one__box-icon"><i :class="detail.icon || 'fa fa-hospital-user'"></i></div>
            <div class="about-one__box-content" data-aos="fade-right" :data-aos-duration="500">
              <h3>{{ detail.title }}</h3>
              <p style="white-space:pre-line">{{ detail.body }}</p>
              <p class="mt-4"><a href="/business" class="octf-btn octf-btn-icon octf-btn-secondary">事業内容へ戻る <i class="bi bi-arrow-right"></i></a></p>
            </div>
          </div>
        </div>
      </div>
      <br/><br/>
    </div>
  </section>
</template>

<script>
const defaults = [
  {section_key:'service_01', title:'国際医療サービス', body:'世界をリードする医療レベルの権威病院を合わせて、お客様に最適な専門家機関を適合させて、高品質な海外受診を享受する', icon:'fa fa-hospital-user'},
  {section_key:'service_02', title:'日本での人材育成', body:'中国と日本の医学発展に貢献し、質の高い介護人材を養成し、各国の医学留学生の日本での就職を促進する', icon:'fa fa-users-medical'},
  {section_key:'service_03', title:'ハイエンドヘルスケアサービス', body:'プロアクティブでハイレベルの医療サービスでご健康を提供し、カスタマイズされたサービスなどを利用して、お客様に至れり尽くせりの標準化された親身的なサービス体験を提供する', icon:'fa fa-heart-pulse'}
];

export default {
  name: 'ServiceDetail',
  data(){ return { detail: { title:'サービス詳細', body:'' } } },
  mounted(){ this.loadDetail(); },
  watch:{ '$route.params.id'(){ this.loadDetail(); } },
  methods:{
    loadDetail(){
      const key = this.$route.params.id || '';
      const setFromList = (list) => {
        const found = (list || []).find(x => String(x.section_key || x.id || '') === String(key));
        this.detail = found || defaults.find(x => x.section_key === key) || defaults[0];
      };
      if (typeof $ !== 'undefined') {
        $.ajax({
          type:'GET',
          url:'/api/page_content.php?page=service&_=' + new Date().getTime(),
          dataType:'json',
          success:(res)=>{
            if(res && res.code===1 && res.list && res.list.length){ setFromList(res.list); }
            else { setFromList(defaults); }
          },
          error:()=>setFromList(defaults)
        });
      } else {
        setFromList(defaults);
      }
    }
  }
}
</script>
